module.exports = {"id":"180818","name":"David McGoldrick","rating":"72","photo":"./data/images/photos/3/180818.png","club":{"name":"Ipswich Town","logo":"./data/images/clubs/IpswichTown.png"},"positions":["BU","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DavidMcGoldrick0.json
// module id = 996
// module chunks = 0